<template>
  <section class="alert">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="15"
      viewBox="0 0 5 15"
    >
      <text
        id="_"
        data-name="!"
        transform="translate(0 12)"
        fill="#3b3b3b"
        font-size="13"
        font-family="Arvo-Bold, Arvo"
        font-weight="700"
      >
        <tspan x="0" y="0">!</tspan>
      </text>
    </svg>
    <p>
      <slot></slot>
    </p>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
.alert {
  display: flex;
  background: $color-primary;
  padding: 16px;
  border-radius: 31px;
  align-items: center;
  width: 100%;
  margin-bottom: 14px;

  p {
    margin-left: 16px;
    font-family: "Arvo", sans-serif;
    font-weight: 900;
    font-size: 14px;
    color: $color-black;
  }
  svg {
    background: $color-white;
    height: 22px;
    width: 22px;
    border-radius: 50%;
  }
}
</style>